// Controllers
import '../../shop/modules/controllers.apply-return-order.js';
import '../../shop/modules/controllers.carts.js';
import '../../shop/modules/controllers.check-store-stock-modal.js';
import '../../shop/modules/controllers.checkout-coupon-list.js';
import '../../shop/modules/controllers.comments.form.js';
import '../../shop/modules/controllers.comments.js';
import '../../shop/modules/controllers.confirmations.new.js';
import '../../shop/modules/controllers.cookie-consent-popup.js';
import '../../shop/modules/controllers.coupon-center.js';
import '../../shop/modules/controllers.coupons.js';
import '../../shop/modules/controllers.esun.js';
import '../../shop/modules/controllers.facebook.quick_sign_up.js';
import '../../shop/modules/controllers.fb-in-app-browser-popup.js';
import '../../shop/modules/controllers.fb-init.js';
import '../../shop/modules/controllers.home.index.js';
import '../../shop/modules/controllers.in-app-browser-popup.js';
import '../../shop/modules/controllers.line.liff.js';
import '../../shop/modules/controllers.line.quick_sign_up.js';
import '../../shop/modules/controllers.member.center.js';
import '../../shop/modules/controllers.member.orders.js';
import '../../shop/modules/controllers.messages.form.js';
import '../../shop/modules/controllers.messages.js';
import '../../shop/modules/controllers.orders.js';
import '../../shop/modules/controllers.passwords.edit.js';
import '../../shop/modules/controllers.passwords.new.js';
import '../../shop/modules/controllers.payment-slip.js';
import '../../shop/modules/product_review_comments/controllers.product_review_comments.orders.js';
import '../../shop/modules/controllers.product-set-basket.js';
import '../../shop/modules/controllers.product.page.js.coffee';
import '../../shop/modules/controllers.product.quick-cart.js';
import '../../shop/modules/controllers.product.variation-picker.js';
import '../../shop/modules/controllers.product.wishlist.js';
import '../../shop/modules/controllers.products.fetch.js';
import '../../shop/modules/controllers.products.search.js';
import '../../shop/modules/controllers.products.show.js';
import '../../shop/modules/controllers.promotion-page.js';
import '../../shop/modules/controllers.quick_registrations.edit.js';
import '../../shop/modules/controllers.quick_registrations.index.js';
import '../../shop/modules/controllers.redeem-gift-cart.js';
import '../../shop/modules/controllers.registrations.edit.js';
import '../../shop/modules/controllers.registrations.new.js';
import '../../shop/modules/controllers.return-orders-show.js';
import '../../shop/modules/controllers.sessions.new.js';
import '../../shop/modules/controllers.slp-product-subscription-credit-card-update-form-modal.js';
import '../../shop/modules/controllers.slp-repay-form-modal.js';
import '../../shop/modules/controllers.users.edit.email_verification.dialog.js';
import '../../shop/modules/controllers.users.edit.js';
import '../../shop/modules/controllers.users.edit.merchant-tiers.dialog.js';
import '../../shop/modules/controllers.users.welcome.js';
import '../../shop/modules/controllers.wishlist.js';
import '../../shop/modules/multi_checkout/controllers.member-center-checkout-object-detail.js';

// Directives
import '../../shop/modules/components/directives.collapse-block.js';
import '../../shop/modules/components/directives.collapse-bottom.js';
import '../../shop/modules/components/directives.collapse-section.js';
import '../../shop/modules/components/directives.coupon-input.js';
import '../../shop/modules/components/directives.coupon-v2.js';
import '../../shop/modules/components/directives.tab-buttons.js';
import '../../shop/modules/directives.address-module.js';
import '../../shop/modules/directives.apple-pay-button.js.coffee';
import '../../shop/modules/directives.apple-pay-with-newebpay-button.js';
import '../../shop/modules/directives.arrival-date-picker.js';
import '../../shop/modules/directives.arrival-time-options.js';
import '../../shop/modules/directives.asiabill-payment.js';
import '../../shop/modules/directives.back-in-stock-button.js';
import '../../shop/modules/directives.basic-popover.js';
import '../../shop/modules/directives.birthday-picker.js';
import '../../shop/modules/directives.carousel-display.js';
import '../../shop/modules/directives.cart-count.js';
import '../../shop/modules/directives.cart-share-btn.js';
import '../../shop/modules/directives.category-filter-button.js';
import '../../shop/modules/directives.category-filter-tags.js';
import '../../shop/modules/directives.category-filter.js';
import '../../shop/modules/directives.check-store-stock-button.js';
import '../../shop/modules/directives.checkout-v2.cart-addons.js';
import '../../shop/modules/directives.checkout-v2.cart-form-pakpobox.js.coffee';
import '../../shop/modules/directives.checkout-v2.cart-form-sfexpress.js.coffee';
import '../../shop/modules/directives.checkout-v2.cart-form.js.coffee';
import '../../shop/modules/directives.checkout-v2.cart-items.js.coffee';
import '../../shop/modules/directives.checkout-v2.cart-page.js.coffee';
import '../../shop/modules/directives.checkout-v2.cart-payment-activity-content.js';
import '../../shop/modules/directives.checkout-v2.cart-promotions.js.coffee';
import '../../shop/modules/directives.checkout-v2.cart-summary.js.coffee';
import '../../shop/modules/directives.checkout-v2.checkout-customer-form.js.coffee';
import '../../shop/modules/directives.checkout-v2.checkout-delivery-ezship.js.coffee';
import '../../shop/modules/directives.checkout-v2.checkout-delivery-family-mart.js.coffee';
import '../../shop/modules/directives.checkout-v2.checkout-delivery-form.js.coffee';
import '../../shop/modules/directives.checkout-v2.checkout-delivery-hop.js.coffee';
import '../../shop/modules/directives.checkout-v2.checkout-delivery-seven-eleven.js';
import '../../shop/modules/directives.checkout-v2.checkout-delivery-sfexpress.js.coffee';
import '../../shop/modules/directives.checkout-v2.checkout-invoice-form.js.coffee';
import '../../shop/modules/directives.checkout-v2.checkout-omise-form.js';
import '../../shop/modules/directives.checkout-v2.checkout-omise-paynow.js';
import '../../shop/modules/directives.checkout-v2.checkout-page.js.coffee';
import '../../shop/modules/directives.checkout-v2.checkout-shopline-payment-cashier.js';
import '../../shop/modules/directives.checkout-v2.checkout-shopline-payment-v2.js';
import '../../shop/modules/directives.checkout-v2.checkout-shopline-payment.js';
import '../../shop/modules/directives.checkout-v2.checkout-two-checkout-payment.js';
import '../../shop/modules/directives.checkout-v2.checkout-shopline-payment-gateway.js';
import '../../shop/modules/directives.checkout-v2.delivery-form-address-option.js';
import '../../shop/modules/directives.checkout-v2.delivery-form-hk-sfplus.js.coffee';
import '../../shop/modules/directives.checkout-v2.delivery-form-three-layer-option.js';
import '../../shop/modules/directives.checkout-v2.member-center-credit-card-shopline-payment-v2.js';
import '../../shop/modules/directives.checkout-v2.order-show-page.js.coffee';
import '../../shop/modules/directives.checkout-v2.store-pick-up-options.js';
import '../../shop/modules/directives.collapsable-cart-promotions.js';
import '../../shop/modules/directives.credit-card-button.js';
import '../../shop/modules/directives.currency-chooser.js';
import '../../shop/modules/directives.customer-cancel-order.js';
import '../../shop/modules/directives.customer-info-auto-fill.js';
import '../../shop/modules/directives.delivery-fee-notice.js';
import '../../shop/modules/directives.dropdown.js';
import '../../shop/modules/directives.dynamic-delivery-fee-info.js';
import '../../shop/modules/directives.dynamic-delivery-fee-notice.js';
import '../../shop/modules/directives.enlarge-image.js';
import '../../shop/modules/directives.facebook-banner.js';
import '../../shop/modules/directives.facebook-messenger-checkbox.js';
import '../../shop/modules/directives.field-group.js';
import '../../shop/modules/directives.form-response.js';
import '../../shop/modules/directives.form.attachment-upload.js';
import '../../shop/modules/directives.form.date-picker.js';
import '../../shop/modules/directives.form.email-input.js';
import '../../shop/modules/directives.form.js';
import '../../shop/modules/directives.form.media-upload.js';
import '../../shop/modules/directives.form.number-input.js';
import '../../shop/modules/directives.ga-page-view.js';
import '../../shop/modules/directives.ga-product.js';
import '../../shop/modules/directives.google-pay-button.js';
import '../../shop/modules/directives.image-banner-display.js';
import '../../shop/modules/directives.intl-tel-control-group.js';
import '../../shop/modules/directives.intl-tel-input-async-event.js';
import '../../shop/modules/directives.intl-tel-input-checkout.js';
import '../../shop/modules/directives.intl-tel-input.js';
import '../../shop/modules/directives.item.variations.js.coffee';
import '../../shop/modules/directives.language-chooser.js';
import '../../shop/modules/directives.line-messenger-checkbox.js';
import '../../shop/modules/directives.link-highlight.js.coffee';
import '../../shop/modules/directives.local-datetime.js';
import '../../shop/modules/directives.lock-inventory-quantity.js';
import '../../shop/modules/directives.member_referral.js';
import '../../shop/modules/directives.member-point-summary.js';
import '../../shop/modules/directives.membership_reminder.js';
import '../../shop/modules/directives.message-toggle.js';
import '../../shop/modules/directives.mobile-check-process.js';
import '../../shop/modules/directives.on-finish-render-filters.js';
import '../../shop/modules/directives.pages.items.instagram.js';
import '../../shop/modules/directives.pages.items.products.js';
import '../../shop/modules/directives.payment-condition-panel.js';
import '../../shop/modules/directives.payment-exist-order-info.js';
import '../../shop/modules/directives.paypal-checkout-button.js';
import '../../shop/modules/directives.paypal-cn-checkout-button.js';
import '../../shop/modules/directives.paypal-fast-checkout-button.js';
import '../../shop/modules/directives.product_available_info.js';
import '../../shop/modules/directives.product_customer_review.js';
import '../../shop/modules/directives.product_review_entry_provider.js';
import '../../shop/modules/directives.product_review_entry.js';
import '../../shop/modules/directives.product-list-variation-selector.js';
import '../../shop/modules/product_review_comments/directives.product-review-comments.form.js';
import '../../shop/modules/product_review_comments/directives.product-review-comments.media-upload.js';
import '../../shop/modules/directives.product-search.js';
import '../../shop/modules/directives.product-set-basket-overview.js';
import '../../shop/modules/directives.product-set-selector.js';
import '../../shop/modules/directives.product.item.js';
import '../../shop/modules/directives.product.variant-gallery.js';
import '../../shop/modules/directives.product.variation-dropdown.js';
import '../../shop/modules/directives.product.variation-label-selector.js';
import '../../shop/modules/directives.products-list.settings.js';
import '../../shop/modules/directives.products.form.addon_products.js';
import '../../shop/modules/directives.products.sort.js';
import '../../shop/modules/directives.promotion-cart.js';
import '../../shop/modules/directives.promotion-date-info.js';
import '../../shop/modules/directives.promotion-term-modal.js';
import '../../shop/modules/directives.promotion.exclude-item.js';
import '../../shop/modules/directives.redeem-gift-item.js';
import '../../shop/modules/directives.redeem-gift-page.js';
import '../../shop/modules/directives.redirect-label.js';
import '../../shop/modules/directives.review_stars.js';
import '../../shop/modules/directives.reward-credit-summary.js';
import '../../shop/modules/directives.safe-html.js';
import '../../shop/modules/directives.shopline_product_review.js';
import '../../shop/modules/directives.shopline-payment-v2-apple-pay-button.js';
import '../../shop/modules/directives.shopline-payment-v2-google-pay-button.js';
import '../../shop/modules/directives.sl-list-page-wishlist-button.js';
import '../../shop/modules/directives.sl-loading-spinner.js';
import '../../shop/modules/directives.sl-wishlist-button.js';
import '../../shop/modules/directives.sms-messenger-checkbox.js';
import '../../shop/modules/directives.star_rating.js';
import '../../shop/modules/directives.tax-fee-info.js';
import '../../shop/modules/directives.tax-fee-notice.js';
import '../../shop/modules/directives.tax-fee.popover.js';
import '../../shop/modules/directives.ui-scrollfix.js';
import '../../shop/modules/directives.user-reminder-desktop.js';
import '../../shop/modules/directives.user-reminder-mobile.js';
import '../../shop/modules/directives.variation-selector.js';
import '../../shop/modules/directives.whatsapp-messenger-checkbox.js';
import '../../shop/modules/directives.yto-store-options.js';
import '../../shop/modules/directives.zeek-pick-up-form.js';
import '../../shop/modules/directives.scm-breadcrumbs.js';

// Unused modules
import '../../shop/modules/services.cancel-request.js';
import '../../shop/modules/services.member.credits.js';
